(() => {
  if (window.rsNavelInstalled) return;
  window.rsNavelInstalled = true;
  const instances = new Map();
  let enginePromise;
  const moduleFor = url => enginePromise || (enginePromise = import(url).catch(error => { enginePromise = null; throw error; }));
  function init(scope) {
    const roots = scope.matches?.('[data-rs-navel]') ? [scope] : scope.querySelectorAll('[data-rs-navel]');
    for (const root of roots) {
      if (instances.has(root)) continue;
      const controller = new AbortController(), signal = controller.signal;
      const guide = root.closest('[data-rs-material-guide]');
      const original = guide.querySelector('[data-rs-original-view]');
      const panel = root.querySelector('[data-navel-panel]');
      const stage = root.querySelector('[data-navel-stage]');
      const host = root.querySelector('[data-navel-host]');
      const poster = root.querySelector('[data-navel-poster]');
      const status = root.querySelector('[data-navel-status]');
      const tools = root.querySelector('[data-navel-tools]');
      const rotate = root.querySelector('[data-navel-rotate]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let engine, mode = '3d', finish = 'gold', pending = false, inView = false, failed = false;
      root.hidden = false; original.hidden = true;
      const activity = () => engine?.setActive(inView && mode === '3d' && !document.hidden);
      const rotationOff = () => { engine?.setRotate(false); rotate.setAttribute('aria-pressed','false'); };
      const originalPhoto = colour => {
        const photo = original.querySelector('.rs-material-guide__photo');
        const url = colour === 'silver' ? root.dataset.photoSilver : root.dataset.photoGold;
        if (photo && url) {
          const matching = [...original.querySelectorAll('[data-rs-photo]')].find(b => b.dataset.rsPhoto === url);
          if (matching) matching.click();
          else { photo.removeAttribute('srcset'); photo.src = url; }
        }
      };
      async function ensure() {
        if (engine || pending || signal.aborted || mode !== '3d') return;
        pending = true; failed = false; delete root.dataset.error; status.textContent = '3D-Ansicht wird geladen …'; stage.setAttribute('aria-busy','true');
        const timer = setTimeout(() => { if (pending && !signal.aborted) status.textContent = 'Die 3D-Ansicht lädt noch. Die Originalfotos kannst du bereits ansehen.'; }, 12000);
        try {
          const module = await moduleFor(root.dataset.engine);
          if (signal.aborted) return;
          const mounted = await module.mountNavel(host, root.dataset.model, signal);
          if (signal.aborted) { mounted.destroy(); return; }
          engine = mounted; engine.setFinish(finish);
          root.dataset.ready = 'true'; root.dataset.finish = finish;
          poster.hidden = true; tools.hidden = false;
          tools.querySelectorAll('button').forEach(b => b.disabled = false);
          status.textContent = ''; activity();
        } catch (error) {
          if (!signal.aborted) { failed = true; root.dataset.error = 'true'; status.textContent = '3D ist gerade nicht verfügbar. Wähle „Originalfotos“, um den Schmuck anzusehen.'; }
        } finally { clearTimeout(timer); pending = false; stage.removeAttribute('aria-busy'); }
      }
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting;
        if (inView && !failed) ensure();
        activity();
      }, { rootMargin: '120px 0px', threshold: .01 }) : null;
      if (observer) observer.observe(root);
      else { inView = true; ensure(); }
      root.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.dataset.navelMode) {
          mode = button.dataset.navelMode;
          root.querySelectorAll('[data-navel-mode]').forEach(b => b.setAttribute('aria-pressed',String(b === button)));
          panel.hidden = mode !== '3d'; original.hidden = mode === '3d';
          rotationOff(); activity();
          if (mode === '3d') ensure();
        }
        if (button.dataset.navelFinish) {
          finish = button.dataset.navelFinish;
          root.querySelectorAll('[data-navel-finish]').forEach(b => b.setAttribute('aria-pressed',String(b === button)));
          poster.src = finish === 'silver' ? root.dataset.posterSilver : root.dataset.posterGold;
          poster.alt = `3D-Visualisierung des Doppelkristall-Piercings in ${finish === 'silver' ? 'Silber' : 'Gold'}`;
          engine?.setFinish(finish); root.dataset.finish = finish; originalPhoto(finish);
        }
        if (button === rotate && engine) {
          const active = rotate.getAttribute('aria-pressed') !== 'true';
          rotate.setAttribute('aria-pressed',String(active)); engine.setRotate(active);
        }
        if (button.hasAttribute('data-navel-reset')) { rotationOff(); engine?.reset(); }
        if (button.hasAttribute('data-navel-zoom-in')) engine?.zoom(.86);
        if (button.hasAttribute('data-navel-zoom-out')) engine?.zoom(1.16);
      }, { signal });
      motion.addEventListener('change', () => { if (motion.matches) rotationOff(); }, { signal });
      document.addEventListener('visibilitychange', activity, { signal });
      host.addEventListener('webglcontextlost', event => {
        event.preventDefault(); engine?.destroy(); engine = undefined; failed = true;
        poster.hidden = false; tools.hidden = true; delete root.dataset.ready;
        status.textContent = '3D wurde angehalten. Du kannst die Originalfotos ansehen oder die 3D-Ansicht erneut wählen.';
      }, { signal, capture: true });
      instances.set(root, () => { controller.abort(); observer?.disconnect(); engine?.destroy(); root.hidden = true; original.hidden = false; });
    }
  }
  const boot = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root,destroy] of instances) if (event.target.contains(root)) { destroy(); instances.delete(root); }
  });
})();
